export default {

    CREATE_APPOINTMENT_REQUEST: 'CREATE_APPOINTMENT_REQUEST',
    CREATE_APPOINTMENT_SUCCESS: 'CREATE_APPOINTMENT_SUCCESS',
    CREATE_APPOINTMENT_FAILURE: 'CREATE_APPOINTMENT_FAILURE',

    RESET_APPOINTMENT_STATE:'RESET_APPOINTMENT_STATE'

};
